// ElevateMN Mock Data

export const siteConfig = {
  name: "ElevateMN",
  tagline: "Elevating Minds. Healing Hearts. Growing Together.",
  description: "A mental health nonprofit supporting Minnesota communities through connection, movement, and shared experience.",
  contact: {
    email: "admin@elevatingmn.com",
    phone: "612-554-1917",
    address: "Maple Grove, MN"
  },
  social: {
    facebook: "https://facebook.com/elevatemn",
    instagram: "https://instagram.com/elevatemn"
  }
};

export const programs = [
  {
    id: 1,
    title: "Men's Mental Health Resets",
    subtitle: "Disc Golf",
    whoFor: "Men seeking connection, stress relief, and a supportive space to talk without stigma.",
    whatItIs: "Disc golf-based mental health resets that pair movement, nature, and peer support.",
    whyItMatters: "Creates an approachable environment for men to engage in mental health conversations."
  },
  {
    id: 2,
    title: "Women's Workshops & Healing Circles",
    subtitle: null,
    whoFor: "Women seeking reflection, empowerment, and emotional support.",
    whatItIs: "Facilitated workshops and healing circles centered on connection and personal growth.",
    whyItMatters: "Strengthens resilience, confidence, and a sense of community belonging."
  },
  {
    id: 3,
    title: "Elevated Takeover @ Ely's Peak",
    subtitle: "Immersive Hike",
    whoFor: "Individuals seeking grounding and clarity through nature.",
    whatItIs: "A guided immersive hike focused on mindfulness and community connection.",
    whyItMatters: "Supports emotional regulation, presence, and collective healing."
  },
  {
    id: 4,
    title: "The Elevated Invitational",
    subtitle: "Cornhole Tournament Fundraiser",
    whoFor: "Community members and supporters looking to give back in a fun, accessible way.",
    whatItIs: "An annual cornhole tournament fundraiser supporting ElevateMN programs.",
    whyItMatters: "Turns community engagement into sustainable impact."
  },
  {
    id: 5,
    title: "Christmas Compassion Toy Drive",
    subtitle: null,
    whoFor: "Families facing financial hardship during the holidays.",
    whatItIs: "A seasonal toy drive that mobilizes community partners across the region.",
    whyItMatters: "In 2025: 15 partner locations, 475 toys collected, supporting 4 families and 3 organizations."
  },
  {
    id: 6,
    title: "Christmas at the Brownstone",
    subtitle: null,
    whoFor: "The entire community.",
    whatItIs: "A celebration highlighting the impact of the Christmas Compassion Toy Drive.",
    whyItMatters: "Honors generosity and strengthens community connection."
  }
];

export const events = [
  {
    id: 1,
    year: 2026,
    title: "The Elevated Escape Camping Retreat (2nd Annual)",
    date: "August 21-23, 2026",
    location: "Camp Waub-O-Jeeg"
  },
  {
    id: 2,
    year: 2025,
    title: "The Elevated Escape Camping Retreat (1st Annual)",
    date: "August 15-17, 2025",
    location: "Camp Waub-O-Jeeg"
  },
  {
    id: 3,
    year: 2025,
    title: "The Elevated Invitational",
    date: "October 18, 2025",
    location: "TBD, Twin Cities Metro"
  },
  {
    id: 4,
    year: 2025,
    title: "Elevated Takeover @ Ely's Peak",
    date: "November 7, 2025",
    location: "Ely's Peak, Duluth"
  },
  {
    id: 5,
    year: 2025,
    title: "Women's Healing Circle",
    date: "November 7, 2025",
    location: "ElevateMN Community Space, Minneapolis"
  },
  {
    id: 6,
    year: 2025,
    title: "Christmas at the Brownstone",
    date: "December 13, 2025",
    location: "The Brownstone, Minneapolis"
  }
];

export const aboutContent = {
  mission: "At ElevateMN, we believe healing starts with community. Our programs are built around connection, movement, and shared experience. We create accessible spaces where people feel supported, seen, and empowered.",
  vision: "A Minnesota where mental health support is accessible, stigma-free, and rooted in community connection.",
  values: [
    {
      title: "Connection",
      description: "We believe that healing happens in relationship with others."
    },
    {
      title: "Accessibility",
      description: "Mental health support should be available to everyone, regardless of circumstance."
    },
    {
      title: "Movement",
      description: "Physical activity and nature are powerful tools for mental wellness."
    },
    {
      title: "Community",
      description: "Together, we are stronger than we are alone."
    }
  ]
};

export const impactStats = [
  { value: "475", label: "Toys Collected (2025)" },
  { value: "15", label: "Partner Locations" },
  { value: "4", label: "Families Supported" },
  { value: "3", label: "Organizations Partnered" }
];
